import { DowntimeImage } from "assets";
import { View, Text, Button } from "native-base";
import React from "react";
import { useTranslation } from "react-i18next";
import { Image } from "react-native";

const DowntimeScreen = () => {
  const { t } = useTranslation("common");
  const tryAgain = () => {
    // reloads app
    window.location.reload();
  };

  return (
    <View flex={1} justifyContent="center" alignContent="center">
      <Image
        source={DowntimeImage}
        style={{
          width: 500,
          height: 500,
          aspectRatio: 1, // maintains square aspect ratio
          resizeMode: "contain", // ensures the image fits within the container
          alignSelf: "center",
          marginBottom: 20,
        }}
      />
      <View alignContent="center" justifyContent="center" paddingLeft={5} paddingRight={5}>
        <Text variant="lg-bold" textAlign="center" marginBottom={5}>
          {t("common.maintenanceText")}
        </Text>

        <Button _text={{ variant: "md-bold" }} variant="solid" onPress={tryAgain} alignSelf="center">
          {t("common.refreshAndCheck")}
        </Button>
      </View>
    </View>
  );
};

export default DowntimeScreen;
